/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export const useNavigate = () => {
    const transform = path => {
        // Look for unified shell URL transformer, see CIF-2484.
        if (window.UNIFIED_SHELL && window.UNIFIED_SHELL.ENABLED === true && window.UNIFIED_SHELL.getUnifiedShellURL) {
            path = window.UNIFIED_SHELL.getUnifiedShellURL(path);
        }

        return path;
    };

    const open = path => {
        // With unified shell enabled, this will be opened in a new window which has to load the unified shell parent
        // frame. Therefore the path needs to be transformed.
        const newWindow = window.open(transform(path), '_blank');
        newWindow && newWindow.focus();
    };

    const location = path => {
        // With unified shell enabled, the path will be opened within the iframe and therefore should not be transformed.
        window.location.href = path;
    };

    return {
        open,
        location
    };
};
